/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';

// import custom component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  radioGroupLabelNamePlan,
  radioGroupInconsistencies,
  rebateProgramLabelName,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import * as Constants from '../../../../SharedModules/AppConstants';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { checkQuarterValidation } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { getCheckBoxValue } from '../../InvoiceAudits/store/Actions';
import {
  getCommonDropdownList,
  getManufacturerList,
  dispatchManufacturerData,
  selectionList,
  handleErrorMessages,
  dropdownUpdatedList,
  getMaximumQuarter,
  searchInconsistencyPayload,
  detailShowPqasData,
  detailShowRosiData,
  dispatchPqasMainGrid,
  dispatchRosiMainGrid,
  dispatchMaxQuarter,
  previousDataQtr,
} from '../store/actions';
import { TableHeaderForManufacturer } from './gridComponents/tableHead';

const CMSInconsistenciesSearch = (props) => {
  const dispatch = useDispatch();

  const getRebateProgramList = useSelector(
    (state) => state.sharedState.CMSROSIPQASReducer?.dropdown
  );
  const getAllManufacturerList = useSelector(
    (state) => state.sharedState.CMSROSIPQASReducer?.manufacturerList
  );
  const getSelectionList = useSelector(
    (state) => state.sharedState.CMSROSIPQASReducer?.selection_list
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.checkbox
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const maximumQuarter = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.maximumQuarter
  );

  const headerInconsistentData = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.headerInconsistentData
  );
  const statusBit = useSelector(
    (state) => state?.sharedState?.CMSROSIPQASReducer?.statusBit
  );
  const getManufacturerListValue = (values) =>
    dispatch(getManufacturerList(values));
  const getQuarterValue = () => dispatch(getMaximumQuarter());

  // variable declaration
  const gridRef = React.useRef();
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [flag, setFlag] = useState(false);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [paramsStore, setParamsStore] = React.useState();
  const [manufCheck, setManufCheck] = React.useState(true);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [rebateDropdownList, setRebateDropdownList] = React.useState([]);

  const indexList = [
    { name: 'All', value: 'ALL' },
    { name: 'By Manufacturer and Rebate Program', value: 'MFG_RP' },
  ];
  const [state, setState] = useState(
    getSelectionList || {
      planTypeCd: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
      rebateProgramCd: userDefaults?.rebateProgramCd
        ? userDefaults?.rebateProgramCd
        : '-1',
      manufacturers: false,
      manufacturerData: [],
      indexRadio: 'ALL',
      quarter: maximumQuarter,
      paginateIndex: 1,
      qtrPaginate: 1,
    }
  );

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // handle all plan type get service on page load
  React.useEffect(() => {
    handleScrollToEvent();

    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue('PLAN_TYPE_CD'));
    }
  }, []);

  // Handle Quarter Value on Changing Rebate Programe

  React.useEffect(() => {
    dispatch(getMaximumQuarter({ rebateProgram: state.rebateProgramCd }));
  }, [state.rebateProgramCd]);

  // set plan type list
  React.useEffect(() => {
    const planList =
      getPlanTypeData &&
      getPlanTypeData.PLAN_TYPE_CD &&
      getPlanTypeData.PLAN_TYPE_CD.length > 0 &&
      getPlanTypeData.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    setPlanTypeOptions(planList);
  }, [getPlanTypeData]);

  // set common dropdown list
  React.useEffect(() => {
    getCommonDropdownList(state.planTypeCd).then((resp) => {
      setRebateDropdownList(resp);
    });
  }, [state.planTypeCd]);
  React.useEffect(() => {
    let list = [];
    if (
      rebateDropdownList?.status === constantMessageData.STATUS_MSG &&
      rebateDropdownList?.message === constantMessageData.SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateDropdownList.data)) {
        list = _.map(rebateDropdownList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
    dispatch(
      dropdownUpdatedList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      )
    );
    setFlag(true);
  }, [rebateDropdownList]);

  // handling highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/rosiInconsistencies', true);
    } else {
      tabHighLigther('/rosiInconsistencies', false);
    }
  }, [errorMessagesFromRedux]);

  // handling grid selection when data is searched
  const callGridSelect = (params) => {
    params &&
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            getAllManufacturerList.findIndex((x) => {
              return x.mfgId === node.data.mfgId && x.value;
            }) && node.setSelected(true)
      );
    const getIndex = getAllManufacturerList.findIndex((x) => {
      return x.value;
    });
    setManufCheck(false);
    if (getIndex === -1) {
      const newObj = getAllManufacturerList?.map((item, index) => {
        if (index === 0) {
          item.value = true;
        } else {
          item.value = false;
        }
        return item;
      });

      setManufacturerList(newObj);
      dispatch(dispatchManufacturerData(newObj));
      params &&
        params.api.forEachNode((node) => {
          node.rowIndex === 0 && node.setSelected(true);
        });
    }
  };

  // handling manufacturer grid tabledata
  React.useEffect(() => {
    const localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    if (getAllManufacturerList.status === '002') {
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    } else if (
      manufCheck &&
      getAllManufacturerList &&
      getAllManufacturerList.length > 0
    ) {
      if (state.manufacturers === false) {
        setManufacturerList(getAllManufacturerList);
      } else {
        setManufacturerList([]);
      }
      callGridSelect(paramsStore);
    } else {
      setManufacturerList([]);
    }
  }, [getAllManufacturerList]);

  // handling quarter value

  React.useEffect(() => {
    if (flag) {
      setState({
        ...state,
        quarter: maximumQuarter,
      });
      if (maximumQuarter && maximumQuarter !== '') {
        let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'quarterFormat'
        );
        dispatch(
          handleErrorMessages({
            searchScreenErrors: [...new Set(localErr)],
            detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
              ? errorMessagesFromRedux?.detailScreenErrors
              : [],
          })
        );
      }
    }
  }, [maximumQuarter]);
  // moving to detail screen
  const moveToDetails = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/rosiInconsistenciesDetail',
      value: 'Display ROSI/PQAS Inconsistencies Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/rosiInconsistenciesDetail',
    });
  };
  // Based on header details, navigation
  React.useEffect(() => {
    const localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    if (headerInconsistentData && headerInconsistentData.status === '001') {
      if (headerInconsistentData?.response.length > 0 && statusBit === 1) {
        dispatch(
          handleErrorMessages({
            searchScreenErrors: [],
            detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
              ? errorMessagesFromRedux?.detailScreenErrors
              : [],
          })
        );
        moveToDetails();
      }
    } else if (
      headerInconsistentData &&
      headerInconsistentData.status === '002'
    ) {
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  }, [headerInconsistentData]);

  // handling by default multiple row selection function
  const onGridReady = (params) => {
    setParamsStore(params);
    if (getAllManufacturerList && getAllManufacturerList?.length > 0) {
      callGridSelect(params);
    }
  };

  // handling On change event on field level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    localErr = localErr.filter(
      (item) => item?.field !== 'search' && item.field !== 'manufacturerData'
    );

    if (name === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      setFlag(true);
      setState({ ...state, [name]: value });
      dispatch(selectionList({ ...state, [name]: value }));
    } else if (name === 'planTypeCd') {
      dispatch(dispatchManufacturerData([]));
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        selectionList({ ...state, [name]: value, rebateProgramCd: '-1' })
      );
    } else if (name === 'quarter') {
      setState({ ...state, [name]: value });
      dispatch(selectionList({ ...state, [name]: value }));
    } else {
      setState({ ...state, [name]: value });
      dispatch(selectionList({ ...state, [name]: value }));
    }

    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };

  // handling On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    localErr = localErr.filter(
      (item) => item?.field !== 'search' && item.field !== 'manufacturerData'
    );
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');

        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }

    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'quarter' && item.field !== 'quarterFormat'
          );

          setState({ ...state, [type]: autoFormateDate(value?.toUpperCase()) });
          dispatch(
            selectionList({
              ...state,
              [type]: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr =
            localErr &&
            localErr?.filter(
              (item) => item.field !== type && item.field !== 'quarterFormat'
            );
          localErr.push({
            field: 'quarterFormat',
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarterFormat');
        localErr.push({
          field: 'quarter',
          errorType: 'quarterRequired',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }

    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const cellClickedListener = (val) => {
    const [selectedRows] = val.api.getSelectedRows();

    searchInconsistentData({
      ...state,
      manufacturerData: [selectedRows.mfgId],
    });
  };
  // select row one by one in manufacturer table grid
  const onRowSelect = (rowData) => {
    setState({ ...state, manufacturerData: rowData });
    const newObj = getAllManufacturerList?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.mfgId === item.mfgId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchManufacturerData(newObj));
  };

  const searchInconsistentData = async (formData) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];

    localErr = localErr.filter(
      (item) =>
        item.field !== 'search' &&
        item.field !== 'manufacturerData' &&
        item.field !== 'quarter'
    );

    let sendManuf = '';
    const getManuf = getAllManufacturerList?.filter((x) => {
      if (x.value === true) {
        sendManuf = x.mfgId;
        return x;
      }
      return false;
    });

    if (state.indexRadio !== 'ALL') {
      if (getManuf?.length === 0 && formData.manufacturers === false) {
        localErr.push({
          field: 'manufacturerData',
          errorType: 'manufacturerRequired',
          message:
            constantMessageData.ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
        });
      }
      if (!formData.rebateProgramCd || formData.rebateProgramCd === '-1') {
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
        });
      }
      if (
        !formData.quarter ||
        formData.quarter === '' ||
        formData.quarter === null
      ) {
        localErr = localErr.filter((item) => item.field !== 'quarterFormat');
        localErr.push({
          field: 'quarter',
          errorType: 'quarterRequired',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }

    if (localErr.length > 0) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      window.scrollTo(0, 0);
    } else {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      const payload = {
        qtr: state.indexRadio === 'ALL' ? 'ALL' : formData.quarter,
        invRecQtr: state.indexRadio === 'ALL' ? 'ALL' : formData.quarter,
        mfgId:
          // eslint-disable-next-line no-nested-ternary
          state.indexRadio === 'ALL'
            ? 'ALL'
            : state.manufacturers === true
            ? 'ALL'
            : sendManuf,
        rebateProgramCd:
          state.indexRadio === 'ALL' ? 'ALL' : formData.rebateProgramCd,
      };
      dispatch(detailShowRosiData(null));
      dispatch(detailShowPqasData(null));
      dispatch(dispatchRosiMainGrid([]));
      dispatch(dispatchPqasMainGrid([]));
      dispatch(previousDataQtr([]));
      dispatch(searchInconsistencyPayload(payload));
      dispatch(selectionList(state));
      //dispatch(dispatchMaxQuarter(state.quarter));
    }
  };

  const searchManufacturerList = async () => {
    setManufCheck(true);
    let localErr = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];

    localErr = localErr.filter(
      (item) =>
        item.field !== 'search' &&
        item.field !== 'manufacturerData' &&
        item.field !== 'quarter'
    );
    if (!state.quarter || state.quarter === '' || state.quarter === null) {
      localErr = localErr.filter((item) => item.field !== 'quarterFormat');
      localErr.push({
        field: 'quarter',
        errorType: 'quarterRequired',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    }
    if (!state.rebateProgramCd || state.rebateProgramCd === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    }
    if (localErr.length > 0) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      window.scrollTo(0, 0);
    } else {
      localErr = [];
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      const payload = {
        qtr: state.quarter,
        invRecQtr: state.quarter,
        mfgTypeCd:
          state.planTypeCd === 'FD' || state.planTypeCd === 'ST' ? 'G' : 'C',
        rebateProgramCd: state.rebateProgramCd,
      };
      const res = await getManufacturerListValue(payload);
      if (res && res.response === 'Record Not Found') {
        localErr.push({
          field: 'search',
          errorType: 'noResults',
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
        });
        dispatch(
          handleErrorMessages({
            searchScreenErrors: [...new Set(localErr)],
            detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
              ? errorMessagesFromRedux?.detailScreenErrors
              : [],
          })
        );
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <div
      className="tabs-container frr-rpinconsistencies-radio"
      data-testid="cms-search"
    >
      <CustomSeparator parent1="Research" parent2="ROSI/PQAS Inconsistencies" />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-8">
              <fieldset
                data-testid="radio-box-component"
                className="radioBtnGroup custom-fieldset h-100"
              >
                <legend className="same-font-family">
                  {radioGroupInconsistencies}{' '}
                </legend>
                <div className="form-wrapper db">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name="index-radio"
                        defaultValue={state && state.indexRadio}
                        value={state && state.indexRadio}
                      >
                        {!_.isEmpty(indexList)
                          ? indexList.map((v, i) => (
                              <FormControlLabel
                                value={v.value}
                                control={
                                  <Radio
                                    onChange={(e) =>
                                      handleOnChangeEvent(v.value, 'indexRadio')
                                    }
                                    data-testid="index-box-group-control"
                                  />
                                }
                                label={v.name}
                                key={v.value && _.kebabCase(v.value)}
                              />
                            ))
                          : null}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 pt-4">
              <div className="text-right">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="view_detail_ia"
                  type="button"
                  onClick={() => {
                    searchInconsistentData(state);
                  }}
                >
                  {' '}
                  <SVGComponent iconName="Icon-search" /> {'  '} Show
                  Inconsistencies
                </Button>
              </div>
            </div>
          </div>
          {state.indexRadio === 'MFG_RP' && (
            <div className="row">
              <div className="col-4 mt-3 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="filter-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName={radioGroupLabelNamePlan}
                  reqColor
                  required
                  optionList={planTypeOptions}
                  defaultValue={state && state.planTypeCd}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'planTypeCd');
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-6 mt-3 frr-two-col-radio">
                <fieldset
                  data-testid="radio-box-component"
                  className="custom-fieldset"
                >
                  {/* <legend className="same-font-family">
                    {rebateProgramLabelName}{' '}
                  </legend> */}
                  <div className="mui-custom-form with-select">
                    <TextField
                      className={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields'
                                  : null
                            )
                          : null
                      }
                      data-testid="rebate_program-ia"
                      id="rebate_program"
                      fullWidth
                      label={rebateProgramLabelName}
                      select
                      required
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={state && state.rebateProgramCd}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      helperText={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'rebateProgramCd';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value=""
                        className="frr-dropdown-blank-item"
                      >
                        {''}
                      </MenuItem>
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </fieldset>
              </div>
              <div className="col-2 mt-5">
                <SelectBoxWithoutBoxComponent
                  data-testid="input-quarter-cms"
                  labelName="Quarter"
                  required
                  select={false}
                  inputProps={{ maxlength: 100 }}
                  name="quarter"
                  defaultValue={(state && state.quarter) || ''}
                  onBlurAction={(e) => handleOnblurEvent('quarter', e)}
                  filterAction={(e) => handleOnChangeEvent(e, 'quarter')}
                  isError={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0 &&
                    _.findIndex(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) =>
                        l.field === 'quarter' || l.field === 'quarterFormat'
                    ) > -1
                      ? _.map(
                          [
                            ...new Set(
                              errorMessagesFromRedux.searchScreenErrors
                            ),
                          ],
                          (l) =>
                            l.field === 'quarter' || l.field === 'quarterFormat'
                              ? l.message
                              : false
                        )
                      : false
                  }
                />
              </div>
            </div>
          )}
          {state.indexRadio === 'MFG_RP' && (
            <div className="row">
              <div className="col-8">
                <FormControlLabel
                  className="ml-0 frr-mt-37"
                  data-testid="manufacturer_checked_ia"
                  control={<Checkbox color="primary" className="" />}
                  label="All&nbsp;Manufacturers"
                  value={state.manufacturers}
                  checked={state.manufacturers}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'manufacturers')
                  }
                />
              </div>
              <div className="col-4">
                <div className="text-right">
                  <Button
                    className="btn btn-success btn-search"
                    data-testid="search_manufacturer_data"
                    type="button"
                    onClick={() => {
                      searchManufacturerList();
                    }}
                  >
                    {' '}
                    <SVGComponent iconName="Icon-search" /> {'  '} Search
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner"
      >
        {state.indexRadio === 'MFG_RP' && state.manufacturers === false ? (
          <TableGrid
            ref={gridRef}
            data-testid="manufacturer-table"
            rowSelection="single"
             selectRowIndex={0}  
            enableFocusOnFirstRender={true}
            gridCall={onGridReady}
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            // eslint-disable-next-line camelcase
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={
              getAllManufacturerList?.length > 0 ? getAllManufacturerList : []
            }
            onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
            cellClickedListener={cellClickedListener}
            columnDefs={TableHeaderForManufacturer}
            exportFile
            animateRows
            sideBar={false}
            fileName="Manufacturer"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            helpMessage={Constants.DOUBLE_CLICK_INFO}
          />
        ) : null}
      </div>
    </div>
  );
};
export default CMSInconsistenciesSearch;
